import { DeclarationConstants } from '../../constants/global';
import { generateImage } from '../../utilities/utils';
import Typography from '@zeptonow/zui/Typography';

const UnauthorizedAccessView = () => {
  return (
    <div className="flex flex-col justify-center items-center text-gray-700 h-[calc(100vh-4rem)]">
      {generateImage({
        name: 'locked-computer',
        alt: 'locked computer image',
        className: 'h-[13.375rem] w-[13.375rem]',
        extension: 'png',
      })}
      <Typography className="w-[22rem] text-center h-6 mb-1 text-base text-gray-900">
        {DeclarationConstants.ACCESS_RESTRICTED}
      </Typography>
      <Typography className="h-5 text-sm text-gray-500">
        {DeclarationConstants.ACCESS_RESTRICTED_MESSAGE}
      </Typography>
    </div>
  );
};

export default UnauthorizedAccessView;
